import { SITE_URL } from '../config';

interface Props {
  storeName: string;
}

const LEGAL_LINKS = [
  { label: 'Privacy', href: `${SITE_URL}/privacy` },
  { label: 'Terms', href: `${SITE_URL}/terms` },
  { label: 'Buyer responsibilities', href: `${SITE_URL}/merchant-buyer-responsibility` },
];

export function StoreFooter({ storeName }: Props) {
  return (
    <footer className="border-t border-black/5 bg-white px-4 py-8">
      <div className="mx-auto flex max-w-6xl flex-col gap-5 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
        <div>
          <p className="text-sm font-semibold text-primary">{storeName}</p>
          <p className="mt-0.5 text-xs text-mid">Shop with confidence. Get help anytime in chat.</p>
        </div>
        <div className="flex flex-col items-center gap-3 sm:items-end">
          <nav aria-label="Legal">
            <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-mid sm:justify-end">
              {LEGAL_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-primary hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <a
            href={SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-1.5 text-xs font-medium text-mid opacity-65 transition-opacity hover:opacity-100"
          >
            <span>Conversational shopping by</span>
            <span className="font-bold" style={{ color: 'var(--brand-accent)' }}>Cartiq</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default StoreFooter;
